import { useEffect, useState } from 'react'
import { getDownloadURL, ref, uploadString } from "firebase/storage";
import { storage } from '../utils/firebase';
import "./style.css"
import { CSVLink } from "react-csv";
import { googleLogout } from '@react-oauth/google';

export default function Video({ user }) {
    const [videoSrc, setVideoSrc] = useState(null)
    const [videos, setVideos] = useState(null)
    const [frames, setFrames] = useState([])
    const [captions, setCaptions] = useState([])
    const [loading, setLoading] = useState(false)
    const [completed, setCompleted] = useState([])
    const [drive, setDrive] = useState(false)

    const extractFrames = (videoFile) => {
        const video = document.createElement('video');
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        const frames = [];

        video.src = videoFile;
        video.muted = true;
        video.play();

        video.onloadeddata = () => {
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            const captureFrame = () => {
                context.drawImage(video, 0, 0, canvas.width, canvas.height);
                const dataUrl = canvas.toDataURL('image/png');
                // frames.push(dataUrl);
                setFrames((prev) => {
                    return [...prev, { time: video.currentTime, url: dataUrl }]
                })

                if (video.currentTime < video.duration) {
                    video.currentTime += 10;
                } else {
                    // setFrames(frames)
                    console.log('All frames extracted:', frames);
                }
            };
            video.ontimeupdate = captureFrame;
        };
    };

    const uploadBase64Image = async (base64Image) => {
        try {
            const filePath = `images/myImage_${Date.now()}.png`;
            const storageRef = ref(storage, filePath);

            await uploadString(storageRef, base64Image, 'data_url');

            const downloadURL = await getDownloadURL(storageRef);
            console.log(downloadURL);

            return downloadURL;
        } catch (error) {
            console.error('Upload failed', error);
            throw new Error(error?.message);
        }
    };

    const getFrames = (images) => {
        let val = []
        for (let index = 0; index < images.length; index++) {
            const element = images[index];
            if (!val?.find((e) => e?.time === element?.time)) {
                val.push(element)
            }
        }
        return val
    }

    const getCaption = async () => {
        try {
            setLoading(true)
            for (let index = 0; index < getFrames(frames)?.length; index++) {
                const frame = getFrames(frames)?.[index]
                const base64 = frame?.url;
                console.log("Getting Caption");
                const token = "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"
                const url = await uploadBase64Image(base64)
                console.log("Image Uploaded");
                console.log("Requesting response from openrouter");
                await fetch('https://openrouter.ai/api/v1/chat/completions', {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        model: 'mistralai/mistral-small-3.1-24b-instruct:free',
                        // model: 'google/gemini-2.0-flash-exp:free',
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    {
                                        "type": "text",
                                        "text": "What is in this image?"
                                    },
                                    {
                                        "type": "image_url",
                                        "image_url": {
                                            "url": url
                                        }
                                    }
                                ]
                            },
                        ],
                        response_format: {
                            type: 'json_schema',
                            json_schema: {
                                "name": "image description",
                                "strict": true,
                                "schema": {
                                    "type": "object",
                                    "properties": {
                                        "description": {
                                            "type": "string",
                                            "description": "Discription of image"
                                        },
                                        "keywords": {
                                            "type": "array",
                                            "items": {
                                                "type": "string",
                                                "description": "Keywords about the image"
                                            }
                                        },
                                    },
                                    "required": ["description", "keywords"],
                                    "additionalProperties": false
                                }
                            }
                        }
                    }),
                }).then(res => res.json())
                    .then(data => {
                        if (data?.choices?.[0]?.message?.content) {
                            setCompleted((prev) => {
                                return [...prev, base64]
                            })
                            // console.log("Response:", data?.choices?.[0]?.message?.content);
                            setCaptions((prev) => {
                                return [...prev, { ...JSON.parse(data?.choices?.[0]?.message?.content), time: frame?.time }]
                            })
                        } else {
                            throw new Error("No response")
                        }
                    })
                    .catch(err => {
                        console.error("Error:", err);
                    });
            }
            setLoading(false)
        } catch (error) {
            console.log("Error", error);
            setLoading(false)
            alert(error?.message)
        }
    }

    function timestamp(seconds) {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);

        return [
            hrs.toString().padStart(2, '0'),
            mins.toString().padStart(2, '0'),
            secs.toString().padStart(2, '0')
        ].join(':');
    }

    const csvData = () => {
        return [
            ["Timestamp", "Description", "Keywords"],
            ...captions?.map((itm) => {
                return [timestamp(itm?.time), itm?.description, itm?.keywords?.join(",\n")]
            })
        ];
    }

    return (
        <>
            <div className='Video'>
                <h2 onClick={() => googleLogout()}>Convert Video To Caption</h2>
                {videoSrc ?
                    <div className='Video_Image'>
                        <video controls src={videoSrc} />
                        <div className='Video_Close1' onClick={() => {
                            setVideoSrc(null)
                            setFrames([])
                            setCaptions([])
                        }}>
                            <CloseIcon />
                        </div>
                    </div>
                    :
                    <>
                        <input id='video-input' hidden onChange={(e) => {
                            setVideoSrc(URL.createObjectURL(e?.target?.files[0]))
                            setVideos(e?.target?.files[0])
                        }} type='file' accept='video/*' />
                        <label htmlFor='video-input'>Choose Video</label>
                        <p style={{ textAlign: "center", margin: "0", marginTop: 20 }}>or</p>
                        <button onClick={() => setDrive(true)}>Choose From Drive</button>
                    </>
                }
                {videoSrc ?
                    <button onClick={() => extractFrames(videoSrc)}>Extract Images</button>
                    : null}
                {frames?.length > 0 ?
                    <>
                        <div className='Video_Image_Con'>
                            {getFrames(frames)?.map((itm) => {
                                return (
                                    <div className='Video_Image'>
                                        <img src={itm?.url} />
                                        <div className='Video_Close' onClick={() => setFrames((prev) => {
                                            return prev?.filter((e) => e !== itm)
                                        })}>
                                            <CloseIcon />
                                        </div>
                                        {completed?.find((e) => e === itm?.url) ?
                                            <div className='Video_Check'>
                                                <CheckIcon />
                                            </div>
                                            : loading ?
                                                <div className='Video_Check'>
                                                    <div className='loader' />
                                                </div>
                                                : null
                                        }
                                        <p>{timestamp(itm?.time)}</p>
                                    </div>
                                )
                            })}
                        </div>
                        <button onClick={() => getCaption()}>{loading ? "Please Wait" : "Get Caption"}</button>
                    </>
                    : null
                }
                {/* {captions?.length > 0 ?
                captions?.map((itm, ind) => {
                    return <p key={ind}>{ind + 1}. {itm?.description}</p>
                })
                : null
            } */}
                {captions?.length > 0 ?
                    <table>
                        <thead>
                            <tr style={{ borderTop: "0px" }}>
                                <th style={{ borderLeft: "0px" }}>Timestamp</th>
                                <th>Description</th>
                                <th>Keywords</th>
                            </tr>
                        </thead>
                        <tbody>
                            {captions?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td style={{ borderLeft: "0px" }}>{timestamp(item?.time)}</td>
                                        <td>{item?.description}</td>
                                        <td>{item?.keywords?.join(",\n")}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    : null}
                {captions?.length > 0 ?
                    <>
                        <CSVLink data={csvData()} filename={`${videos?.name}.csv`}>Download as CSV</CSVLink>
                    </>
                    : null}
                <div className='Video_End_Con' />
            </div>
            <div className={drive ? 'Modal Modal_Show' : 'Modal'}>
                <DiveFiles show={drive} setShow={setDrive} user={user} setVideoSrc={setVideoSrc} />
            </div>
        </>
    )
}

function DiveFiles({ setShow, show, user, setVideoSrc }) {
    const [videos, setVideos] = useState([])

    async function listDriveFiles(accessToken) {
        try {
            const query = encodeURIComponent(
                "mimeType contains 'video/' and trashed = false"
            );
            const res = await fetch(
                `https://www.googleapis.com/drive/v3/files?q=${query}&pageSize=50&fields=files(id,name,mimeType)`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (!res.ok) throw new Error('Failed to list files');

            const data = await res.json();
            setVideos(data.files)
            return data.files;
        } catch (err) {
            console.error('Error fetching drive files:', err);
        }
    }

    const [loading, setLoading] = useState(false)

    const getFileUrl = async (fileId, accessToken) => {
        setLoading(fileId)
        const url = `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch video content.');
        }

        const blob = await response.blob();
        const bloburl = URL.createObjectURL(blob);
        setVideoSrc(bloburl)
        setLoading(false)
        setShow(false)
    };

    useEffect(() => {
        if (show && videos?.length === 0) {
            listDriveFiles(user?.access_token)
        }
    }, [show])

    return (
        <div className='Modal_Con'>
            <div className='Modal_Close' onClick={() => setShow(false)}>
                <CloseIcon />
            </div>
            {videos?.map((itm, ind) => {
                return (
                    <div onClick={()=>getFileUrl(itm?.id, user?.access_token)} key={ind} className='Modal_Con_Video'>
                        <p>{itm?.name}</p>
                        {loading === itm?.id?
                        <div className='loader' />
                        : null}
                    </div>
                )
            })}
        </div>
    )
}

function CloseIcon() {
    return (
        <svg height={17} width={17} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Menu / Close_SM"> <path id="Vector" d="M16 16L12 12M12 12L8 8M12 12L16 8M12 12L8 16" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g> </g></svg>
    )
}

function CheckIcon() {
    return <svg height={30} width={30} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Interface / Check"> <path id="Vector" d="M6 12L10.2426 16.2426L18.727 7.75732" stroke="#00ff22ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g> </g></svg>
}